/* tslint:disable */
/* eslint-disable */
export enum WorkElektroDrittkontrolleSortByEnum {
  ImplementingAsc = 'implementing:ASC',
  ImplementingDesc = 'implementing:DESC',
  AcdcSinaUploadAsc = 'acdcSinaUpload:ASC',
  AcdcSinaUploadDesc = 'acdcSinaUpload:DESC',
  ElektroDrittkontrolleStartAsc = 'elektroDrittkontrolleStart:ASC',
  ElektroDrittkontrolleStartDesc = 'elektroDrittkontrolleStart:DESC'
}
